export class CategoryWiseActAndBudgetForLastThreeYrsDetails{
    year:number;
    categoryName:string;
    actual:number;
    budget:number;
    isTotal:number;
    isGrandTotalBudget:number;
}